import React from 'react'
import { useStyles } from './styles'
import { concatStyles } from 'src/utils'

interface DividerProps {
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({ className }) => {
  const { dividerWrapper } = useStyles()
  return (
    <div className={concatStyles(dividerWrapper, className)}/>
  )
}
